import { Sezzle } from "@ThirdParty/Sezzle";
import "@ThirdParty/TagManager";

export class Window
{
	/**
	 * Constructs the window object for exposing global functions
	 */
	constructor()
	{
		window.Fun.ThirdParty = {
			Sezzle: new Sezzle()
		};
	}
}

new Window();